import React, { useEffect, useState } from "react";
import { CardText, Row, Col } from "reactstrap";
import "assets/scss/website/app.scss";
import "react-rangeslider/lib/index.css";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import "react-multi-carousel/lib/styles.css";
import { useSelector, useDispatch } from "react-redux";
import { appendFilters, resetFilters } from "store/filter/actions"
import "./styles.scss"
import { useTranslation } from 'react-i18next';
import RoomFilter from "./RoomFilter";

const TopFilter = ({ id, setLoading, loading, topFilterError, setTopFilterError}) => {
  const filterData = useSelector(state => state.filter);
  const AuthData = useSelector(state => state.Auth)
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [bedRomms, setBedRomms] = useState([])
  const [bathRomms, setBathRomms] = useState([])
  const [floors, setFloors] = useState([])

  const showLoading=()=> setLoading(true)

  useEffect(()=>{
    setBedRomms(filterData?.bedrooms)
    setBathRomms(filterData?.bathrooms)
    setFloors(filterData?.floor)
  },[id])

  const onSlide = (...rest) => {
    dispatch(appendFilters({ budget: rest[0], page: 1 }))
    showLoading()
  };

  const onSlideSize = (...rest) => {
    dispatch(appendFilters({ size: rest[2], page: 1 }))
    showLoading()
  };
  
  return (
    <div className=' p-3'style={{position:"relative", background:"#ffffff", "boxShadow": "0 0 5px #dedede"}}>
    {loading ? <div style={{opacity:".6",zIndex:300,background:"#ffffff",position:"absolute",width:"100%",height:"100%",top:0,left:0}}></div>:null}
      <AvForm >
           <div className={`mb-2 d-flex ${topFilterError ? 'justify-content-between': 'flex-row-reverse'}`}>
              {topFilterError && <CardText tag='h6' className={`fw-bold pt-3 error`}>
                Choose a filter, then click on Interactive Mode
              </CardText>}
              <button
                className='btn shadow-none rest-Btn font-size-14 text-dark px-0 '
                type="button"
                onClick={() =>{
                  dispatch(resetFilters())
                  showLoading()
                }}>{t("reset all")}</button>
            </div>
          <Row>
            <Col md={6} style={{borderRight: '1px solid #dedede'}}>
              <Col md={12}>
                <CardText tag='h6' className={`fw-bold pt-3 ${topFilterError ? 'error' : ''}`}>
                  {t("property type")}
                </CardText>
                <div
                  className='d-block btn-group-toggle'
                  data-toggle='buttons'>
                  {filterData.unitTypeOptions.map((type, index) => {
                    return (
                      <span key={index}>
                        <input
                          type='checkbox'
                          className='btn-check'
                          name='UnitType'
                          id={`btncheckType${index}`}
                          autoComplete='off'
                          checked={filterData.unitType.some(item => item?.name?.en === type ?.name?.en)}
                          onChange={() => { }}
                        />
                        <label
                          onClick={() => {
                            const isExist = filterData.unitType.some(item => item?.name?.en === type ?.name?.en)
                            if (!isExist) {
                              setTopFilterError(false)
                              dispatch(appendFilters({ unitType: [...filterData.unitType, type], page: 1}))
                              showLoading()
                            } else {
                              const updatedData = filterData.unitType.filter(item => item?.name?.en !== type ?.name?.en)
                              dispatch(appendFilters({ unitType: [...updatedData], page: 1 }))
                              showLoading()
                            }
                          }}

                          className='btn btn-outline-light    me-2'
                          style={{
                            background: filterData.unitType.some(item => item?.name?.en === type ?.name?.en) ? "#0583f2" : "#f5f5f5",
                            color: filterData.unitType.some(item => item?.name?.en === type ?.name?.en) ? "#fff" : "#000",
                          }}
                          htmlFor='UnitType'>
                          {type?.name?.en}
                        </label>
                      </span>
                    )
                  })}
                </div>
              </Col>
              <Col md={12} style={{borderTop: '1px solid #dedede'}}>
                <CardText tag='h6' className={`fw-bold pt-3 ${topFilterError ? 'error' : ''}`}>
                  {t("finishing")}
                </CardText>
                <div
                  className='d-block btn-group-toggle'
                  data-toggle='buttons'>
                  {filterData.finishingOptions.map((type, index) => {
                    return (
                      <span key={index + 1}>
                        <input
                          type='checkbox'
                          className='btn-check'
                          name='typeFinish'
                          id={`typeFinish${index + 1}`}
                          autoComplete='off'
                          checked={filterData.finishingType.some(item => item?.name?.en === type?.name?.en)}

                          onChange={() => { }}
                        />
                        <label
                          style={{
                            background: filterData.finishingType.some(item => item?.name?.en === type?.name?.en) ? "#0583f2" : "#f5f5f5",
                            color: filterData.finishingType.some(item => item?.name?.en === type?.name?.en) ? "#fff" : "#000",
                          }}
                          onClick={() => {
                            const isExist = filterData.finishingType.some(item => item?.name?.en === type?.name?.en)
                            if (!isExist) {
                              setTopFilterError(false)
                              dispatch(appendFilters({ finishingType: [...filterData.finishingType, type], page: 1 }))
                              showLoading()
                            } else {
                              const updatedData = filterData.finishingType.filter(item => item?.name?.en !== type?.name?.en)
                              dispatch(appendFilters({ finishingType: [...updatedData], page: 1 }))
                              showLoading()
                            }
                          }}
                          className='btn btn-outline-light me-2'
                          htmlFor='btncheckType'>
                          {type?.name?.en}
                        </label>
                      </span>
                    )
                  })}
                </div>
              </Col>
              <Col md={12} style={{borderTop: '1px solid #dedede'}}>
                <CardText tag='h6' className={`fw-bold pt-3 ${topFilterError ? 'error' : ''}`}>
                  {t("Categories")}
                </CardText>
                <div
                  className='d-block btn-group-toggle pt-1'
                  data-toggle='buttons'>
                  {filterData.CategortiesOptions.map((type, index) => {
                    return (
                      <span key={index}>
                        <input
                          type='checkbox'
                          className='btn-check'
                          name='typeCatogory'
                          id={`typeCatogory${index}`}
                          autoComplete='off'
                          onChange={() => { }}
                          checked={filterData.categories_ids.some(item => item?.name?.en === type ?.name?.en)}

                        />
                        <label
                          style={{
                            background: filterData.categories_ids.some(item => item?.name?.en === type ?.name?.en) ? "#0583f2" : "#f5f5f5",
                            color: filterData.categories_ids.some(item => item?.name?.en === type?.name?.en) ? "#fff" : "#000",
                          }}
                          onClick={() => {
                            const isExist = filterData.categories_ids.some(item => item?.name?.en === type?.name?.en)
                            if (!isExist) {
                              setTopFilterError(false)
                              dispatch(appendFilters({ categories_ids: [...filterData.categories_ids, type], page: 1 }))
                              showLoading()
                            } else {
                              const updatedData = filterData.categories_ids.filter(item => item?.name?.en !== type?.name?.en)
                              dispatch(appendFilters({ categories_ids: [...updatedData], page: 1 }))
                              showLoading()
                            }
                          }}
                          className='btn btn-outline-light me-2'
                          htmlFor='btncheckType'>
                          {type?.name?.en}
                        </label>
                      </span>
                    )
                  })}
                </div>
              </Col>
            </Col>
            <Col md={3} className='px-3'>
              <Col md={12}>
                <div
                  className='d-block btn-group-toggle'
                  data-toggle='buttons'>
                  <CardText tag='h6' className={`fw-bold pt-3 ${topFilterError ? 'error' : ''}`}>
                  {t("Floors")}
                  </CardText>
                  <RoomFilter setTopFilterError={setTopFilterError} roomsType={"floorRange"} value={'floor'} showLoading={showLoading}  />
                </div>
              </Col>
              <Col md={12} style={{borderTop: '1px solid #dedede'}}>
                <div
                  className='d-block btn-group-toggle'
                  data-toggle='buttons'>
                  <CardText tag='h6' className={`fw-bold pt-3 ${topFilterError ? 'error' : ''}`}>
                    {t("Bedrooms")}
                  </CardText>
                  <RoomFilter setTopFilterError={setTopFilterError} roomsType={"bedroomsRange"} value={'bedrooms'} showLoading={showLoading} />
                </div>
              </Col>
              <Col md={12} style={{borderTop: '1px solid #dedede'}}>
                <div
                  className='d-block btn-group-toggle'
                  data-toggle='buttons'>
                  <CardText tag='h6' className={`fw-bold pt-3 ${topFilterError ? 'error' : ''}`}>
                  {t("Bathrooms")}
                  </CardText>
                  <RoomFilter setTopFilterError={setTopFilterError} roomsType={"bathroomsRange"} value={'bathrooms'} showLoading={showLoading}  />
                </div>
              </Col>
            </Col>
            <Col md={3}>
              {!!filterData.size &&<Col md={12}>
              <div className='mt-2'>
                <CardText tag='h6' className='fw-bold pt-3'>
                  {t("size")} ({t("sqm")})
                </CardText>
                <Row className=" d-flex justify-content-between mb-2">
                  <Col md={6}><span className="fw-bold font-size-14 text-muted" > 
                  { Math.round(filterData.size[0]) }
                  </span>
                  </Col>
                  <Col md={6} className="d-flex flex-row-reverse p-0 text-muted">
                  <span className="fw-bold font-size-14 px-2">
                  { Math.round(filterData.size[1])}
                  
                  </span></Col>
                </Row>
                {AuthData.lang==="ar" ?            <Nouislider
                  range={{ min: filterData.sizeRange[0], max: filterData.sizeRange[1] }}
                  tooltips={false}
                  step={10}
                  start={filterData.size}
                  connect
                  onSlide={onSlideSize}
                  direction={"rtl"}
                />:null}
                {AuthData.lang!=="ar" ?  <Nouislider
                  range={{ min: filterData.sizeRange[0], max: filterData.sizeRange[1] }}
                  tooltips={false}
                  step={10}
                  start={filterData.size}
                  connect
                  onSlide={onSlideSize}
                  direction={"ltr"}
                />:null}
              </div>
              </Col>}
              {!!filterData.budget && <Col md={12} className='mt-3' style={{borderTop: '1px solid #dedede'}}>
              <div className='mt-2'>
              <CardText tag='h6' className='fw-bold' >{t("budget")}</CardText>
              <Row className=" d-flex justify-content-between mb-2">
                <Col md={6}>
                <span className="fw-bold font-size-14 text-muted" >
                {  toCurrency(filterData.budget[0])  } </span></Col>
                <Col md={6} className="d-flex flex-row-reverse p-0 text-muted">
                <span className="fw-bold font-size-14 px-2"> { toCurrency(filterData.budget[1]) } </span></Col>
              </Row>
            {AuthData.lang==="ar" ? <Nouislider
                range={{ min: filterData.budgetRange[0], max: filterData.budgetRange[1] }}
                step={5000}
                tooltips={false}
                start={filterData.budget}
                connect
                onSlide={onSlide}
                direction={"rtl"}


              />:null}
              {AuthData.lang!=="ar"?<Nouislider
              range={{ min: filterData.budgetRange[0], max: filterData.budgetRange[1] }}
              step={5000}
              tooltips={false}
              start={filterData.budget}
              connect
              onSlide={onSlide}
              direction={"ltr"}


            />:null}
              </div>
              </Col>}
            </Col>
          </Row>
       </AvForm>
    </div>
  );
};

const toCurrency = (number) => {
  const formatter = new Intl.NumberFormat("en-US");
  return formatter.format(number);
}

export default TopFilter;